import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  close() {
    this.element.close();
  }

  closeOnSuccess(event) {
    if (event.detail.success) this.element.close();
  }
}
